import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Auth/AuthContext';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Constant/Custom/Loader';

function Rank() {
    const { auth } = useContext(AuthContext);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [csrfToken, setCsrfToken] = useState('');
    const navigate = useNavigate();
    const [lockStatus, setLockStatus] = useState('N');
    const [ischoicefilling, setischoicefilling] = useState(false);
    const [appno, setAppno] = useState('');
    const storedUser = auth.user;
    const [showButton, setShowButton] = useState(true)

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const checkSession = async () => {
            try {


                if (!storedUser) {
                    throw new Error('No active session found');
                }

                if (!storedUser.appno || !storedUser.mobile || !storedUser.email) {
                    throw new Error('Incomplete session data');
                }

                const dataToSend = {
                    appno: storedUser.appno,
                    mobile: storedUser.mobile,
                    email: storedUser.email
                };

                const response = await axios.post(`${serverUrl}/api/user/get-rank`,
                    dataToSend,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': csrfToken
                        }
                    });

                if (response.status === 200 && response.data) {
                    // console.log(response.data);
                    setUser(response.data);
                    if (response.data.sex === "Male") {
                        localStorage.setItem('sex', 'Male');

                    }


                } else if (response.status === 404) {
                    throw new Error('User data not found');
                } else {
                    throw new Error('Failed to load user data from the server');
                }

            } catch (error) {
                console.error('Error fetching session:', error);
                setError(error.message);
                if (error.message === 'User data not found') {
                    navigate('/not-found');
                } else {
                    // navigate('/login');
                }
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, [navigate]);

    const fetchChoiceLockstatus = async () => {
        try {
            const res = await axios.post(`${serverUrl}/api/choicefilling/user/choices/checklockstatus`, {
                appNo: storedUser.appno
            },
                //  {
                // headers: {
                // 'Content-Type': 'application/json',
                // 'CSRF-Token': csrfToken,
                // },
                // withCredentials: true,
                // }
            )
            setLockStatus(res.data.lockstatus)
            setischoicefilling(res.data.ischoicefilling)
        }
        catch (error) {
            console.log(error.response.status);

            if (error.response.status == 404) {
                setShowButton(false)
            }

        }



    }
    useEffect(() => {
        fetchChoiceLockstatus();

    }, [user]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }
    return (
        <div className='homePage' style={{ fontFamily: 'Arial, sans-serif' }}>
            <div className='welcomeApplicant' style={{ marginBottom: '20px' }}>
                {user ? (
                    <>
                        <h1>{user.userName}</h1>
                        <div style={{ lineHeight: '1.6', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '200%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Name of the Student</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.userName}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Application No</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.appno}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Email ID</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.email}</p>
                            </div>
                            {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Date of Reg</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.dateOfReg}</p>
                            </div> */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Sex / Gender</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.sex}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Community</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.community}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>University Register No.</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.univRegNo}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>CUT-OFF</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.average}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Overall Rank</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.overallRank}</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p style={{ flex: '1' }}><b>Community Rank</b></p>
                                <p style={{ flex: '1', textAlign: 'left' }}>{user.communityRank}</p>
                            </div>
                            {lockStatus === "L" && (<>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <p style={{ flex: '1' }}><b>Choice Lock Status</b></p>
                                    <p style={{ flex: '1', textAlign: 'left' }}>Choice Locked</p>
                                </div>
                            </>)

                            }

                        </div>
                    </>
                ) : (
                    <div>No user data available</div>
                )}
            </div>
            <div className='ProceedButton'>
                {
                     showButton && ischoicefilling && (
                        lockStatus == "L"? (
                            <button
                                type='button'
                                onClick={() => navigate('/dashboard/choicefilling')}

                            >
                                Proceed to Download choice list
                            </button>) : (
                            <button
                                type='button'
                                onClick={() => navigate('/dashboard/choicefilling')}

                            >
                                Proceed to Choice Filling
                            </button>
                        )

                    )
                }


            </div>
        </div>
    );
}

export default Rank;